import axios from 'axios'
import BASE_URL from '../config/api.js'


const RECOMMENDATIONS_URL = BASE_URL + "/recommendations"


class RecommendationsResource {
    
    getRecommendationsAnd(preferences, consumer) {


        var choices = []
        for(const step in preferences) {
            choices = choices.concat(preferences[step])
        }
        const request = {
            choices: choices
        }

        // Return the object to possibly handle the error
        return axios.post(RECOMMENDATIONS_URL, request)
            .then(response => consumer(response.data.images))
    }

}

const recommendationsApi = new RecommendationsResource()

export default recommendationsApi
